import { SEO } from "../components/shared/SEO";
import { PageHeader } from "../components/shared/PageHeader";
import { Reveal } from "../components/shared/Reveal";
import { ServiceCards, MethodTimeline, CTABand } from "../components/shared/Sections";
import { IMAGES } from "../content/site";

export default function CosaFacciamo() {
  return (
    <>
      <SEO title="Sviluppo e Riqualificazione Immobiliare | Home Haven" description="Analisi, sviluppo, frazionamento, ristrutturazione e valorizzazione: Home Haven coordina ogni fase delle operazioni immobiliari." image={IMAGES.interior} />
      <PageHeader eyebrow="Cosa facciamo" title="Dall'opportunità immobiliare alla creazione di valore" image={IMAGES.interior} text="Copriamo l'intera catena del valore di un'operazione immobiliare: individuazione, analisi economica, trasformazione e strategia di uscita." />
      <section className="section bg-cream">
        <div className="container-hh"><ServiceCards /></div>
      </section>
      <section className="section bg-white">
        <div className="container-hh">
          <Reveal className="mb-20"><div className="eyebrow mb-6">Il nostro metodo</div><h2 className="h-section max-w-3xl">Ogni operazione segue sei fasi.</h2></Reveal>
          <MethodTimeline />
        </div>
      </section>
      <CTABand eyebrow="Collabora con noi" title="Un immobile da trasformare o un capitale da investire?" primary={{ to: "/proponi-immobile", label: "Proponi un immobile", testId: "services-cta-proponi" }} secondary={{ to: "/investitori", label: "Investi con noi", testId: "services-cta-investi" }} />
    </>
  );
}
